/*
 * The plan a visitor picked on publifying.com/pricing, which arrives as
 * /register?package=<slug>. Kept in localStorage (not sessionStorage) so it
 * survives email verification in another tab, a refresh, and Google/Facebook
 * signup round-trips, and is still there for the payment page right after.
 * The server also remembers it on the account (users.selected_package_slug);
 * this copy just covers the moments before an account exists.
 *
 * Only the public slug is stored — never a price. Prices are always read fresh.
 */
const KEY = 'pf_selected_package';
const SLUG = /^[a-z0-9][a-z0-9-]{0,99}$/;

export function getSelectedPackage() {
  try {
    const value = localStorage.getItem(KEY) || '';
    return SLUG.test(value) ? value : '';
  } catch {
    return '';
  }
}

export function setSelectedPackage(slug) {
  try {
    if (slug && SLUG.test(slug)) localStorage.setItem(KEY, slug);
  } catch {
    /* storage unavailable — the server-side copy still covers the payment page */
  }
}

export function clearSelectedPackage() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
